module.exports = __webpack_public_path__ + "static/media/especialidades.cc2de8ea.png";